import React, { type ComponentProps, type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import type { TriggerProps } from '@atlaskit/popup';
import { Box, Pressable } from '@atlaskit/primitives/compiled';

import type { PopupTriggerWithHover } from '../../popup-adapter/PopupTriggerWithHover';

const styles = cssMap({
	trigger: {
		all: 'unset',
		display: 'inline',
	},
});

type TeamProfileCardTriggerProps = {
	trigger?: ComponentProps<typeof PopupTriggerWithHover>['triggerMode'];
	triggerProps: TriggerProps;
	children: ReactNode;
};

export const TeamProfileCardTrigger = ({ trigger, triggerProps, children }: TeamProfileCardTriggerProps) => {
	const isNonInteractiveHoverTriggerEnabled = fg('townsquare_team_profilecard_non_interactive_hover_trigger');

	const hoverOnlyTrigger = Array.isArray(trigger) ? trigger.every(mode => mode === 'hover') : trigger === 'hover';
	const useNonInteractiveHoverTrigger = isNonInteractiveHoverTriggerEnabled && hoverOnlyTrigger

	if (useNonInteractiveHoverTrigger) {
		const {
			'aria-expanded': _ariaExpanded,
			...nonDialogTriggerProps
		} = triggerProps;

		return (
			<Box
				as="span"
				{...nonDialogTriggerProps}
				testId="team-profilecard-trigger-wrapper"
				xcss={styles.trigger}
			>
				{children}
			</Box>
		);
	}

	return (
		<Pressable
			{...triggerProps}
			testId="team-profilecard-trigger-wrapper"
			xcss={styles.trigger}
		>
			{children}
		</Pressable>
	);
}
